export default __webpack_public_path__ + "media/transfer_window/transfer_password-2-f60b2273.jpg";